import React, { FC, memo } from 'react'
import { useTranslate } from 'react-polyglot'
import { Alert, Typography } from '@getgo/chameleon-web-react-wrapper'
import { Box } from '@material-ui/core'

interface ErrorMessageProps {
  error: {
    error: Error
  }
}

const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => {
  const t = useTranslate()

  return error?.error?.message ? (
    <Box p={4}>
      <Alert variant="danger">
        <Typography variant="body-medium">
          {t('There was an error loading this application. Please try again later.')}
        </Typography>
        <Typography variant="caption-small">
          {t('Error:')} {error.error.message}
        </Typography>
      </Alert>
    </Box>
  ) : null
}

export default memo(ErrorMessage)
